export class ConfiguracoesForm {
  public static aprovaCliente;
  public static produtoDetalhe
  static cadastroCliente: any;
  
  public static patchAppConfig(c) {
    this.aprovaCliente = c.aprovaCliente;
    this.produtoDetalhe = c.produtoDetalhe
    this.cadastroCliente = c.cadastroCliente
  }
}
